
import Call from '../Network/Json';

import ExternalConfiguration, { EnvironmentsKeys, DomainsKeys } from '../../external-configuration';

export default Call;

export function getDomain( domainKey = DomainsKeys.CMS) {
  const Environments = ExternalConfiguration.EnvDomains ?? {};
  const environment = Environments[process.env.NODE_ENV] ?? Environments[EnvironmentsKeys.default];
  return environment[domainKey];
}

export function buildApiBasePath( domainKey = DomainsKeys.CMS) {
  const Domain = getDomain( domainKey);
  return `${Domain}${ExternalConfiguration.CMSApiBasePath}`;
}
